export default function Checkout() {
    return(
        <div className="container-fluid bg-success text-light d-flex align-items-center justify-content-center p-4">
            <h1>Thank You For Your Purchase! We will notify you once we have prepared your orders for shipping!</h1>
        </div>
    )
}